import { forwardRef } from 'react';
import { StyledModalExit } from './styled';
import { useModalContext } from '../../../contexts/modal';
import Icon from '../../../components/Icon';

const ModalExit = forwardRef((props, ref) => {
  const { exitProps } = useModalContext();

  return (
    <StyledModalExit {...exitProps(ref, props)}>
      <Icon name="exit" />
    </StyledModalExit>
  );
});

export default ModalExit;
